import { createEnvironment } from '@meta-press/environments';

export const environment = createEnvironment({
	production: false,
	apiUrl: 'https://meta-press-dev-hhd6b9brg4epb2hb.swedencentral-01.azurewebsites.net',
	// AIEndPoint: '/api/v1/AzureOpenAi',
	useDummyBackend: false,

	showProductionPlugins: true,
	showBetaPlugins: true,
	showAlphaPlugins: true,
	showPrototypePlugins: false,

	showInternalPlugins: true,

	// serviceMode: true,

	serviceMessageTitle: 'Palvelua päivitetään',
	serviceMessageText: `Olemme huoltotauolla. Palvelu avataan uudestaan entistä ehompana perjantaina 10.10. kello 12:00. Pahoittelemme tästä mahdollisesti aiheutuvaa haittaa.`,

	username: '',
	password: '',
});
